import jsSHA from "jssha"
import { getCookie } from "./cookies"

const meets = (roles) => {
  const jwtCokie = getCookie("jwt")

  if (!jwtCokie) return !roles || roles.length === 0

  const tkn = parseJwt(jwtCokie)
  return roles.includes(tkn.role)
}

const parseJwt = (token) => {
  var base64Url = token.split(".")[1]
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join("")
  )

  /*
    {
      "fresh": false,
      "iat": 1637860371,
      "jti": "b5f5d2dc-da62-48ef-9b06-4cfaa82c1bfc",
      "type": "access",
      "sub": 1,
      "nbf": 1637860371,
      "exp": 1637861271,
      "role": "admin"
    }
  */

  return JSON.parse(jsonPayload)
}

const sha256 = (message) => {
  const shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" })
  shaObj.update(message)
  const hash = shaObj.getHash("HEX")

  return hash
}

export { parseJwt, sha256, meets }
